import DeviceAction from '../../../components/actions/DeviceAction/DeviceAction';
import SendEmail from '../../../components/actions/SendEmail/SendEmail';
import PublishIpawsAlert from '../../../components/actions/PublishIpawsAlert/PublishIpawsAlert';
import DateTime from '../../../components/conditions/DateTime';
import DeviceCondition from '../../../components/conditions/DeviceCondition/DeviceCondition';
import DeviceGroup from '../../../components/conditions/DeviceGroup';
import FusionAlertCondition from '../../../components/conditions/FusionAlertCondition';
import NWSAlertGACondition from '../../../components/conditions/NWSAlert.ga';

export const builderComponentRegistry = {
  Device: {
    category: 'Device',
    sections: ['conditions', 'until'],
    createInitialFormData: () => ({
      node_id: '',
      deviceType: '',
      keyToCheck: '',
      keyToCompare: '',
      operator: '',
      valueToCompare: '',
      selectedDevice: '',
      inputValueType: false,
      error: true,
    }),
    render: (props) => <DeviceCondition {...props} />,
  },
  'Device Group': {
    category: 'Device Group',
    sections: ['conditions', 'until'],
    createInitialFormData: () => ({ error: true }),
    render: (props) => <DeviceGroup {...props} />,
  },
  'Date & Time': {
    category: 'Date & Time',
    sections: ['conditions', 'until'],
    createInitialFormData: () => ({ dateTime: '', date: '', time: '', error: true }),
    render: (props) => <DateTime type="dateTime" {...props} />,
  },
  Date: {
    category: 'Date',
    sections: ['conditions', 'until'],
    createInitialFormData: () => ({ dateTime: '', date: '', time: '', error: true }),
    render: (props) => <DateTime type="date" {...props} />,
  },
  Time: {
    category: 'Time',
    sections: ['conditions', 'until'],
    createInitialFormData: () => ({ dateTime: '', date: '', time: '', error: true }),
    render: (props) => <DateTime type="time" {...props} />,
  },
  'NWS Alert': {
    category: 'NWS Alert',
    sections: ['conditions'],
    createInitialFormData: () => ({ value: '', error: true }),
    render: (props) => <NWSAlertGACondition {...props} />,
  },
  'Fusion Alert': {
    category: 'Fusion Alert',
    sections: ['conditions'],
    createInitialFormData: () => ({ selectedAlertType: '', error: true }),
    render: (props) => <FusionAlertCondition {...props} />,
  },
  'Original Condition Resolved': {
    category: 'Original Condition Resolved',
    sections: ['until'],
    createInitialFormData: () => ({}),
    render: () => null,
  },
  'Device Action': {
    category: 'Device Action',
    sections: ['actions'],
    createInitialFormData: () => ({ error: true }),
    render: (props) => <DeviceAction {...props} />,
  },
  'Device Group Action': {
    category: 'Device Group Action',
    sections: ['actions'],
    createInitialFormData: () => ({ error: true }),
    render: (props) => <DeviceAction {...props} isGroup={true} />,
  },
  'Send Email': {
    category: 'Send Email',
    sections: ['actions'],
    createInitialFormData: () => ({
      subject: '',
      body: '',
      recipient: '',
      recipients: [{ recipient: '', carrier: '' }],
      error: true,
    }),
    render: (props) => <SendEmail {...props} />,
  },
  'Send SMS': {
    category: 'Send SMS',
    sections: ['actions'],
    createInitialFormData: () => ({
      subject: '',
      body: '',
      recipient: '',
      recipients: [{ recipient: '', carrier: '' }],
      error: true,
    }),
    render: (props) => <SendEmail {...props} sms={true} />,
  },
  'Publish IPAWS Alert': {
    category: 'Publish IPAWS Alert',
    sections: ['actions'],
    createInitialFormData: () => ({}),
    render: (props) => <PublishIpawsAlert {...props} />,
  },
};
